// Native Web Push API — works on iOS PWA without FCM
const VAPID_PUBLIC_KEY = 'BNuVOzENBu0cuP_h5mYty70nx2McUED7mfr4cHB18Oexr0ZOfvl2BvREPKNAucleTPi74Y9vIY35e-foNj_xWkM';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Subscribe to push notifications using the native Push API
export const subscribeToPush = async () => {
  try {
    console.log('[Push] 1️⃣ Starting push subscription setup...');
    
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      console.error('[Push] Push notifications not supported');
      return null;
    }

    if (Notification.permission !== 'granted') {
      console.error('[Push] Notification permission not granted');
      return null;
    }

    console.log('[Push] 2️⃣ Registering service worker...');
    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log('[Push] ✅ Service worker registered');
    
    console.log('[Push] 3️⃣ Waiting for service worker to be ready...');
    const reg = await navigator.serviceWorker.ready;
    console.log('[Push] ✅ Service worker ready');

    console.log('[Push] 4️⃣ Checking for existing push subscription...');
    let subscription = await reg.pushManager.getSubscription();
    
    if (subscription) {
      console.log('[Push] ✅ Existing subscription found:', subscription.endpoint.substring(0, 50) + '...');
      localStorage.setItem('pushSubscription', JSON.stringify(subscription.toJSON()));
      return subscription;
    }
    
    console.log('[Push] No existing subscription found');
    console.log('[Push] 5️⃣ Creating new push subscription...');
    console.log('[Push] VAPID key (first 20 chars):', VAPID_PUBLIC_KEY.substring(0, 20));
    
    const applicationServerKey = urlBase64ToUint8Array(VAPID_PUBLIC_KEY);
    console.log('[Push] Application server key length:', applicationServerKey.length);

    // Check permission state before subscribing
    const permissionState = await reg.pushManager.permissionState({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey
    });
    console.log('[Push] Permission state for push manager:', permissionState);
    
    subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: applicationServerKey,
    });
    
    console.log('[Push] ✅✅✅ New subscription created successfully!');
    localStorage.setItem('pushSubscription', JSON.stringify(subscription.toJSON()));
    return subscription;
  } catch (error) {
    console.error('[Push] ❌❌❌ Subscribe error:', error);
    console.error('[Push] Error name:', error.name);
    console.error('[Push] Error message:', error.message);
    console.error('[Push] Error stack:', error.stack);
    return null;
  }
};

// Schedule a push notification via the background function (server waits, then sends)
export const schedulePushNotification = async (delaySeconds, title, body, timerId) => {
  try {
    const subJson = localStorage.getItem('pushSubscription');
    if (!subJson) {
      console.log('[Push] No subscription — skipping push schedule');
      return false;
    }

    const subscription = JSON.parse(subJson);

    // Background function returns 202 immediately, waits server-side, then sends
    const response = await fetch('/.netlify/functions/schedule-push-background', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ subscription, delaySeconds, title, body, timerId }),
    });

    console.log('[Push] Schedule response:', response.status);
    return response.ok || response.status === 202;
  } catch (error) {
    console.error('[Push] Schedule error:', error.message);
    return false;
  }
};

// Cancel a scheduled push notification by writing to Supabase database
export const cancelPushNotification = async (timerId, userEmail) => {
  try {
    if (!timerId || !userEmail) {
      console.error('[Push] Missing timer ID or user email for cancellation');
      return false;
    }

    // Write to Supabase database - backend function checks this before sending
    const { createClient } = await import('@supabase/supabase-js');
    const supabase = createClient(
      process.env.REACT_APP_SUPABASE_URL,
      process.env.REACT_APP_SUPABASE_ANON_KEY
    );
    
    const { error } = await supabase
      .from('cancelled_timers')
      .insert({
        timer_id: timerId,
        user_email: userEmail,
        cancelled_at: new Date().toISOString()
      });
    
    if (error) {
      console.error('[Push] Database cancel failed:', error.message);
      return false;
    }
    
    console.log('[Push] Timer cancelled in database:', timerId);
    return true;
  } catch (error) {
    console.error('[Push] Cancel error:', error.message);
    return false;
  }
};
